import { all } from 'email-misspelled';
const DomainsOverride = all;
DomainsOverride.push('yopmail.com', 'gmail.col');
export { DomainsOverride };